<script>
import mixin from '@/plans/mx/shopping-cart';
import { debounce, sortBy } from 'lodash';
import { BILLING_CYCLE, planTypes } from '@/common/constants';
import { capacityFormatter, capitalizeFirstLetter } from '@/common/utils';
import { mapGetters, mapMutations } from 'vuex';
import AltProratedPlanUser from '@/views/config/shopping-cart/prorated/plan-user.vue';
import AltProratedPlanPrice from '@/views/config/shopping-cart/prorated/plan-price.vue';
import AltProratedPlanPeriod from '@/views/config/shopping-cart/prorated/plan-period.vue';
import { isFromShoppingCart } from '@/views/config/shopping-cart/persist/plan-remove';

export default {
  mixins: [mixin],
  components: {
    AltProratedPlanUser,
    AltProratedPlanPrice,
    AltProratedPlanPeriod,
  },
  computed: {
    ...mapGetters(['getSelectedPlans']),
    oneTimeWebinarTotalLicenses() {
      return this.getSelectedPlans
        .filter((p) => p.type === planTypes.WEBINAR && p.billing_cycle === BILLING_CYCLE.ONE_TIME)
        .reduce((p, c) => p + c.cartInfo.selected_number, 0);
    },
    selectedSingleUsePro() {
      return this.getSelectedPlans.find(
        (p) => p.type === planTypes.ZOOM_MEETING && p.billing_cycle === BILLING_CYCLE.ONE_TIME,
      );
    },
    singleUsePlanQuantityCompare() {
      return [this.oneTimeWebinarTotalLicenses, this.selectedSingleUsePro?.cartInfo?.selected_number ?? 0];
    },
    isContainWebinarSingleUse () {
      return this.getSelectedPlans.some(plan => plan?.plan_code === "zo_pro_single_use")
    },
    canRmv() {
      if(isFromShoppingCart() && this.isContainWebinarSingleUse) {
        return false;
      }
      return true;
    }
  },
  watch: {
    singleUsePlanQuantityCompare: {
      handler: debounce(function (nv) {
        // Recalculate single-use pro licenses when a user removes a webinar single-use plan from the checkout page
        const [webinarQuantity, singleProQuantity] = nv;
        if (webinarQuantity > 0 && singleProQuantity > 0 && webinarQuantity !== singleProQuantity) {
          this.updateSelectPlan({
            plan_code: this.selectedSingleUsePro?.plan_code,
            cartInfo: { selected_number: webinarQuantity },
          });
        }
      }, 300),
    },
  },
  methods: {
    ...mapMutations(['updateSelectPlan']),
    $renderPrice() {
      if (!this.mx_plans.length) return;
      return (
        <div class="opc-cart-item">
          {this.mx_main_title(this.$t('billing.webinar.title'), undefined, this.mx_plans[0]?.parent_category)}
          {sortBy(this.mx_plans, 'participants').map((plan) => {
            return (
              <div>
                {this.mx_subTitle(
                  `${capacityFormatter(plan.participants)} ${capitalizeFirstLetter(this.$t('billing.attendees'))}`,
                  <AltProratedPlanPrice type={plan.type} code={plan.plan_code}>{this.$money(this.webinarPrice(plan))}</AltProratedPlanPrice>,
                  plan?.plan_code,
                )}
                {this.mx_discount(plan.plan_code)}
                <AltProratedPlanUser type={plan.type} code={plan.plan_code}>{this.mx_license(plan.cartInfo.selected_number, this.$t('billing.planform.unit.license'))}</AltProratedPlanUser>
                {this.mx_cycle(
                  plan.billing_cycle,
                  plan.billing_cycle === BILLING_CYCLE.ONE_TIME
                    ? this.$t('billing.single_use_meeting.within_three_months')
                    : '',
                )}
                <AltProratedPlanPeriod type={plan.type} code={plan.plan_code} />
                {this.mx_edit(plan)}
                {this.canRmv && this.mx_remove(plan)}
              </div>
            );
          })}
        </div>
      );
    },
    $renderAgreement() {
      return <div class="opc-cart-item__text"></div>;
    },
    webinarPrice(plan) {
      if (plan.billing_cycle === BILLING_CYCLE.ONE_TIME) {
        return plan.cartInfo.selected_number * (plan.amount + plan?.esmd_amount || 0);
      }
      return this.mx_price(plan);
    },
  },
};
</script>
